<template>
	<LazyImage
		:src="avatar"
		:alt="username"
		v-if="avatar && !error"
		@error="onError"
		class="flex-shrink-0 rounded-full"
		:class="{ 'outline outline-2 outline-offset-2 outline-pink': active }"
		v-bind="$attrs"
	/>
	<div
		v-if="error || !avatar"
		class="flex flex-shrink-0 items-center justify-center rounded-full text-center text-xs font-medium uppercase text-white"
		:class="[
			{ 'outline outline-2 outline-offset-2 outline-pink': active },
			hashAvatar
		]"
		v-bind="$attrs"
	>
		{{ username[0] }}
	</div>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import LazyImage from './LazyImage.vue'

const props = defineProps<{
	avatar?: string
	active?: boolean
	username: string
}>()

defineOptions({
	inheritAttrs: false
})

const error = ref(false)

watch(
	() => props.avatar,
	() => {
		error.value = false
	}
)

const onError = () => {
	error.value = true
}

const hashAvatar = computed(() => {
	const colors = ['bg-pink', 'bg-cyan', 'bg-green', 'bg-lava', 'bg-orange']
	let hash = 0

	for (let i = 0; i < props.username.length; i++) {
		const char = props.username.charCodeAt(i)
		hash = (hash << 5) - hash + char
		hash = hash & hash
	}

	return colors[Math.abs(hash) % colors.length]
})
</script>
